(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["top-brand-circles"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('top-brand-scroll')) {
  customElements.define('top-brand-scroll', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.top-subcategory-nav');
      this.buttons = Array.from(this.querySelectorAll('[data-direction]'));
      if (!this.track || this.buttons.length !== 2) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.update = () => {
        const max = this.track.scrollWidth - this.track.clientWidth;
        const position = Math.abs(this.track.scrollLeft);
        this.buttons[0].disabled = position <= (parseFloat(getComputedStyle(this.track).paddingLeft) || 0) + 2;
        this.buttons[1].disabled = position >= max - 2;
      };
      this.buttons.forEach(button => button.addEventListener('click', () => {
        const card = this.track.querySelector('.top-subcategory-card');
        if (!card) return;
        const stride = card.getBoundingClientRect().width + (parseFloat(getComputedStyle(this.track).columnGap) || 0);
        const count = Math.max(1, Math.floor(this.track.clientWidth / stride));
        const rtl = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
        this.track.scrollBy({
          left: Number(button.dataset.direction) * rtl * stride * count,
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
        });
      }, options));
      this.track.addEventListener('scroll', this.update, { ...options, passive: true });
      this.classList.add('is-ready');
      this.resize = new ResizeObserver(this.update);
      this.resize.observe(this.track);
      this.update();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.resize?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-first-order"] && !Shopify.designMode) return;
  try {
    
if (!window.topFirstOrderCopyBound) {
  window.topFirstOrderCopyBound = true;
  document.addEventListener('click', async function(event) {
    const button = event.target.closest('[data-top-copy-coupon]');
    if (!button) return;
    const code = button.dataset.topCopyCoupon;
    const status = button.parentElement.querySelector('[role="status"]');
    let copied = false;
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(code);
        copied = true;
      }
    } catch (error) {}
    if (!copied) {
      const field = document.createElement('textarea');
      field.value = code;
      field.setAttribute('readonly', '');
      field.style.cssText = 'position:fixed;top:0;left:-9999px;font-size:16px';
      document.body.appendChild(field);
      field.select();
      field.setSelectionRange(0, field.value.length);
      try { copied = document.execCommand('copy'); } catch (error) {}
      field.remove();
      button.focus({preventScroll:true});
    }
    status.textContent = copied ? button.dataset.copied : button.dataset.failed;
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-home-carousel"] && !Shopify.designMode) return;
  try {
    
function initTopCarousels(scope=document){
 scope.querySelectorAll('[data-top-carousel]').forEach(root=>{
  if(root.dataset.ready)return;
  root.dataset.ready='true';
  const track=root.querySelector('.top-carousel__track');
  const slides=[...track.children];
  const dots=[...root.querySelectorAll('[data-top-dot]')];
  const pause=root.querySelector('[data-top-pause]');
  const reduced=matchMedia('(prefers-reduced-motion: reduce)');
  const manualOnly=matchMedia('(max-width: 768px), (hover: none) and (pointer: coarse)');
  let index=0,timer=null,settleTimer=null,scrolling=false,destroyed=false,hover=false,touch=false,visible=false,paused=reduced.matches,editing=false;
  const stop=()=>{clearTimeout(timer);timer=null;};
  const settled=()=>{
   clearTimeout(settleTimer);
   scrolling=false;
   index=Math.max(0,Math.min(slides.length-1,Math.round(track.scrollLeft/track.clientWidth)));
   dots.forEach((dot,i)=>dot.setAttribute('aria-current',String(i===index)));
   schedule();
  };
  const waitForSettle=()=>{
   stop();
   scrolling=true;
   clearTimeout(settleTimer);
   settleTimer=setTimeout(settled,180);
  };
  const move=i=>{
   waitForSettle();
   const next=(i+slides.length)%slides.length;
   const wrap=next===0&&index===slides.length-1;
   index=next;
   track.scrollTo({left:track.clientWidth*index,behavior:reduced.matches||wrap?'auto':'smooth'});
  };
  const schedule=()=>{
   stop();
   if(manualOnly.matches||destroyed||scrolling||slides.length<2||paused||hover||touch||!visible||editing||document.hidden||root.contains(document.activeElement))return;
   timer=setTimeout(()=>move(index+1),3000);
  };
  const syncMode=()=>{if(pause)pause.hidden=manualOnly.matches;schedule();};
  manualOnly.addEventListener('change',syncMode);
  syncMode();
  const manual=i=>move(i);
  root.querySelector('[data-top-prev]').addEventListener('click',()=>manual(index-1));
  root.querySelector('[data-top-next]').addEventListener('click',()=>manual(index+1));
  dots.forEach((dot,i)=>dot.addEventListener('click',()=>manual(i)));
  if(pause){
   const update=()=>{pause.setAttribute('aria-pressed',String(paused));pause.firstElementChild.textContent=paused?'▶':'Ⅱ';};
   update();
   pause.addEventListener('click',()=>{paused=!paused;update();schedule();});
  }
  root.addEventListener('pointerenter',e=>{if(e.pointerType==='mouse'){hover=true;stop();}});
  root.addEventListener('pointerleave',e=>{if(e.pointerType==='mouse'){hover=false;schedule();}});
  root.addEventListener('pointerdown',()=>{touch=true;stop();});
  const release=()=>{if(touch){touch=false;schedule();}};
  window.addEventListener('pointerup',release);
  window.addEventListener('pointercancel',release);
  root.addEventListener('focusin',stop);
  root.addEventListener('focusout',()=>setTimeout(schedule,0));
  document.addEventListener('visibilitychange',schedule);
  track.addEventListener('scrollend',settled);
  track.addEventListener('scroll',()=>{
   waitForSettle();
   index=Math.round(track.scrollLeft/track.clientWidth);
   dots.forEach((dot,i)=>dot.setAttribute('aria-current',String(i===index)));
  },{passive:true});
  track.addEventListener('keydown',e=>{
   if(e.key==='ArrowRight'){e.preventDefault();manual(index+1);}
   if(e.key==='ArrowLeft'){e.preventDefault();manual(index-1);}
  });
  const resize=new ResizeObserver(()=>track.scrollTo({left:track.clientWidth*index,behavior:'auto'}));
  resize.observe(track);
  const observer=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;schedule();},{threshold:.3});
  observer.observe(root);
  root.addEventListener('shopify:block:select',e=>{editing=true;stop();const slide=e.target.closest('.top-carousel__slide');if(slide)move(slides.indexOf(slide));});
  root.addEventListener('shopify:block:deselect',()=>{editing=false;schedule();});
  root.closest('.shopify-section')?.addEventListener('shopify:section:unload',()=>{
   destroyed=true;stop();manualOnly.removeEventListener('change',syncMode);clearTimeout(settleTimer);resize.disconnect();observer.disconnect();
   track.removeEventListener('scrollend',settled);
   document.removeEventListener('visibilitychange',schedule);
   window.removeEventListener('pointerup',release);window.removeEventListener('pointercancel',release);
  },{once:true});
 });
}
initTopCarousels();
document.addEventListener('shopify:section:load',e=>initTopCarousels(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-viral-carousel"] && !Shopify.designMode) return;
  try {
    
function initViralCarousels(scope=document){
 scope.querySelectorAll('[data-viral-carousel]').forEach(root=>{
  if(root.dataset.ready)return;
  root.dataset.ready='true';
  const track=root.querySelector('.top-viral__track');
  const slides=[...root.querySelectorAll('[data-viral-slide]')];
  const dots=[...root.querySelectorAll('[data-viral-dot]')];
  let index=0;
  const move=i=>{index=(i+slides.length)%slides.length;track.scrollTo({left:index*track.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});};
  root.querySelector('[data-viral-prev]')?.addEventListener('click',()=>move(index-1));
  root.querySelector('[data-viral-next]')?.addEventListener('click',()=>move(index+1));
  dots.forEach((dot,i)=>dot.addEventListener('click',()=>move(i)));
  track.addEventListener('scroll',()=>{index=Math.max(0,Math.min(slides.length-1,Math.round(track.scrollLeft/track.clientWidth)));dots.forEach((dot,i)=>dot.setAttribute('aria-current',String(i===index)));},{passive:true});
  track.addEventListener('keydown',e=>{if(e.key==='ArrowRight'){e.preventDefault();move(index+1);}if(e.key==='ArrowLeft'){e.preventDefault();move(index-1);}});
  slides.forEach(slide=>{
   slide.querySelectorAll('[data-viral-pin]').forEach(pin=>pin.addEventListener('click',()=>{
    slide.querySelectorAll('[data-viral-pin]').forEach(p=>p.setAttribute('aria-pressed',String(p===pin)));
    slide.querySelectorAll('[data-viral-product]').forEach(card=>{card.hidden=card.dataset.viralProduct!==pin.dataset.viralPin;});
   }));
  });
  const resize=new ResizeObserver(()=>track.scrollTo({left:index*track.clientWidth,behavior:'auto'}));resize.observe(track);
  root.addEventListener('shopify:block:select',e=>{const slide=e.target.closest('[data-viral-slide]');if(slide)move(slides.indexOf(slide));});
  root.closest('.shopify-section')?.addEventListener('shopify:section:unload',()=>resize.disconnect(),{once:true});
 });
}
initViralCarousels();
document.addEventListener('shopify:section:load',e=>initViralCarousels(e.target));

  } catch(e) { console.error(e); }
})();
})();
